import { getPf } from "./utils/conf";

export const toStdLanguages = (lang: string) => {
  switch (lang) {
    case "ko":
    case "kr":
      return "ko";
    case "jp":
    case "ja":
      return "jp";
    case "cn":
      return "cn";
    case "es":
      return "es";
    case "en":
    case "us":
    default:
      return "en";
  }
};

export const getDefaultLanguage = (): string => {
  const isTravity = getPf() === "TRAVITY";
  if (!isTravity) return "ko"; // Default to Korean for TAMICE
  const x = localStorage.lang ?? (isTravity ? "jp" : "ko");
  if (x === "ko") return "jp";
  return toStdLanguages(x ? x : "ko");
};
